import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { EmptyStateIllustrationOnboardingCompleted } from "@dreamhub/designsystem/icons";

const OnboardingCompletedEmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="flex items-center justify-center w-full h-full min-h-[600px]"
      data-test="contract-detailed-view-onboarding-completed"
    >
      <div className="flex flex-col md:flex-row items-center gap-10 max-w-[760px]">
        <div className="flex-shrink-0">
          <EmptyStateIllustrationOnboardingCompleted />
        </div>
        <div className="flex flex-col gap-5 max-w-[320px]">
          <Text variant="lgSubtitleH1">
            {t("contracts.detailedView.onboarding.completedTitle")}
          </Text>
          <Text variant="lgBodySecondary">
            {t("contracts.detailedView.onboarding.completedDescription")}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default OnboardingCompletedEmptyState;
